module.exports = __webpack_public_path__ + "e95db4aad0b8c50abfeab942203ae5d4.svg";